import { TagVariant } from '@creditornot/cb-tag';

import {
  DeliveryMethodV2,
  DeliveryProviderType,
  DeliveryStatusV2,
} from 'apis/merchant-gateway/merchant-analytics/types';
import { DeliveryProvider, DeliveryStatus } from 'apis/restaurant-api/merchant-admin/purchases/types';

export const NUM_PURCHASES_PER_PAGE = 40;

export const ROW_HEIGHT = 57;

// Translation strings for delivery types
export const DELIVERY_TYPES: { [key in DeliveryMethod]: string } = {
  eatin: 'purchases.delivery-types.eatin',
  homedelivery: 'purchases.delivery-types.homedelivery',
  takeaway: 'purchases.delivery-types.takeaway',
};

export const DELIVERY_TYPES_V2: { [key in DeliveryMethodV2]: string } = {
  EATIN: 'purchases.delivery-types.eatin',
  HOMEDELIVERY: 'purchases.delivery-types.homedelivery',
  TAKEAWAY: 'purchases.delivery-types.takeaway',
};

export const DELIVERY_PROVIDERS: { [key in DeliveryProvider]: string } = {
  'wolt-delivery': 'purchases.delivery-providers.wolt-delivery',
  'self-delivery': 'purchases.delivery-providers.self-delivery',
};

export const DELIVERY_PROVIDER_TYPES: { [key in DeliveryProviderType]: string } = {
  WOLT: 'purchases.delivery-providers.wolt-delivery',
  SELF: 'purchases.delivery-providers.self-delivery',
};

// Purchases older than 90 days are not queryable with the purchases API. They are archived to a separate database.
export const EARLIEST_SUPPORTED_DATETIME_FROM_NOW_IN_DAYS = 90;

export const DELIVERY_STATUS_TAG_VARIANTS: { [key in DeliveryStatus]: TagVariant } = {
  delivered: 'lightBlue',
  production: 'lightOrange',
  ready: 'lightGreen',
  received: 'lightBlack',
  acknowledged: 'lightBlack',
  rejected: 'lightRed',
  refunded: 'lightDarkBlue',
};

export const DELIVERY_STATUS_TAG_VARIANTS_V2: { [key in DeliveryStatusV2]: TagVariant } = {
  DELIVERED: 'lightBlue',
  PRODUCTION: 'lightOrange',
  READY: 'lightGreen',
  RECEIVED: 'lightBlack',
  ACKNOWLEDGED: 'lightBlack',
  REJECTED: 'lightRed',
  REFUNDED: 'lightDarkBlue',
  FETCHED: 'lightBlack',
};

export const DELIVERY_STATUSES: { [key in DeliveryStatus]: string } = {
  delivered: 'purchases.delivery-statuses.delivered',
  production: 'purchases.delivery-statuses.production',
  ready: 'purchases.delivery-statuses.ready',
  received: 'purchases.delivery-statuses.received',
  acknowledged: 'purchases.delivery-statuses.acknowledged',
  rejected: 'purchases.delivery-statuses.rejected',
  refunded: 'purchases.delivery-statuses.refunded',
};

export const DELIVERY_STATUSES_V2: { [key in DeliveryStatusV2]: string } = {
  DELIVERED: 'purchases.delivery-statuses.delivered',
  PRODUCTION: 'purchases.delivery-statuses.production',
  READY: 'purchases.delivery-statuses.ready',
  RECEIVED: 'purchases.delivery-statuses.received',
  ACKNOWLEDGED: 'purchases.delivery-statuses.acknowledged',
  REJECTED: 'purchases.delivery-statuses.rejected',
  REFUNDED: 'purchases.delivery-statuses.refunded',
  FETCHED: 'purchases.delivery-statuses.fetched',
};

export const RATING_TEXTS: Record<number, string> = {
  1: 'insights.ratings-and-reviews.rating-level-name.1',
  2: 'insights.ratings-and-reviews.rating-level-name.2',
  3: 'insights.ratings-and-reviews.rating-level-name.3',
  4: 'insights.ratings-and-reviews.rating-level-name.4',
  5: 'insights.ratings-and-reviews.rating-level-name.5',
};
